/** @format */

import { IKeyAuth, IThemeColor } from "types";
import { KEY_CONTEXT } from "utils";

export function useKey() {
  const TvcSSO = window?.["TvcSSO"];

  const setKeyLang = (value) => {
    localStorage.setItem(KEY_CONTEXT.LANGUAGE, value);
  };

  const setKeySC = (value) => {
    localStorage.setItem(KEY_CONTEXT.SC_CONNECTION_TOKEN, value);
  };

  const setKeyTheme = (value) => {
    localStorage.setItem(KEY_CONTEXT.THEME_MODE, value);
  };
  const setKeyUser = (user) => {
    localStorage.setItem(KEY_CONTEXT.USER, JSON.stringify(user));
  };

  const setKeySite = ({
    authToken,
    refreshToken,
    userId,
    updateParent = false,
  }: IKeyAuth) => {
    if (updateParent) {
      TvcSSO.setValue(KEY_CONTEXT.REFRESH_TOKEN, refreshToken);
      TvcSSO.setValue(KEY_CONTEXT.AUTH_TOKEN, authToken);
      localStorage.setItem(KEY_CONTEXT.USER_ID, userId!);
    }
    localStorage.setItem(KEY_CONTEXT.AUTH_TOKEN, authToken);
    localStorage.setItem(KEY_CONTEXT.REFRESH_TOKEN, refreshToken);
    localStorage.setItem(KEY_CONTEXT.USER_ID, userId!);
  };

  const removeKeySite = (updateParent = false) => {
    if (updateParent) {
      TvcSSO.setValue(KEY_CONTEXT.REFRESH_TOKEN, "");
      TvcSSO.setValue(KEY_CONTEXT.AUTH_TOKEN, "");
      localStorage.setItem(KEY_CONTEXT.USER_ID, "");
    }
    localStorage.removeItem(KEY_CONTEXT.AUTH_TOKEN);
    localStorage.removeItem(KEY_CONTEXT.REFRESH_TOKEN);
    localStorage.setItem(KEY_CONTEXT.USER_ID, "");
  };

  // custom get value
  const getKey = (key: string) => {
    return key === KEY_CONTEXT.THEME_MODE
      ? localStorage.getItem(key) || "main"
      : localStorage.getItem(key);
  };

  // custom remove value
  const removeKey = (key: string) => {
    return localStorage.removeItem(key);
  };

  const themeMode = (getKey(KEY_CONTEXT.THEME_MODE) || "main") as IThemeColor;

  const logout403 = async () => {
    removeKey("deviceId");
    removeKeySite();
    const myItem = localStorage.getItem("firstLogin");
    localStorage.clear();
    myItem && localStorage.setItem("firstLogin", "true");
    window.location.href = "/";
    return;
  };

  return {
    themeMode,
    setKeyLang,
    setKeyTheme,
    setKeyUser,
    setKeySite,
    getKey,
    removeKey,
    removeKeySite,
    setKeySC,
    logout403,
  };
}
